import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from 'axios';
import store from '@/store';
import HandlePaginateService from "@/services/HandlePaginateService";

export default {
  name: "hostelList",
  components: {
    MainLayout,
    Select2Multiple,
    flatPickr,
    Loading,
    CONFIG,
    AdvancedLaravelVuePaginate
  },

  data() {
    return {
      hostelData: {},
      searchData: {
        name: '',
        type: null
      },
      isFilterOpen: false,
      isLoading: false,
      search_status: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      campusId: store.state.user.campus_id,
      searchBtnStatus: false,
      searchedData: null,
      isSearched: false,
    };
  },

  methods: {
    reset() {
      this.searchData.name = ''
      this.searchData.type = null
      this.isLoading = true;
      this.getHostel();
      this.isSearched = false;
    },
    searchHostel(page = 1) {
      this.searchBtnStatus = true;
      this.isLoading = true;
      var request = {
        params: {
          name: this.searchData.name,
          type: this.searchData.type,
          campus_id: this.$store.state.user.campus_id
        }
      }

      this.searchedData = {
        ...request.params,
        search_status: this.searchBtnStatus
      };
      this.isSearched = true;
      axios.get("/hostel/search?page=" + page, request)
        .then(response => {
          this.search_status = true;
          this.hostelData = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Hostel Search API Error", error);
        });
    },
    getHostel(page = 1) {
      this.searchBtnStatus = false;
      axios.get('hostel/list?page=' + page, {
        params: {
          campus_id: this.campusId,
        }
      })
        .then(res => {
          if (res.data) {
            this.hostelData = res.data;
            this.isLoading = false
          }
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Hostel List API Error", error);
        });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete hostel and its boarders?")) {
        this.delete(id);
      }
    },

    delete(id) {
      axios.delete("/hostel/delete/" + id)
        .then(res => {
          if (res.data.success == true) {
            this.isLoading = true;
            this.getHostel();
            this.$notification.success("Hostel Deleted Successfully.", {
              timer: 3,
              position: "bottomCenter"
            });
          }

        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },
    showCreate() {
      this.$router.push({
        path: "/hostel/create"
      });
    },

    showEdit(id) {
      this.$router.push({
        name: "hostelEdit",
        params: {
          id: id
        }
      });
    },

    showDetail(id) {
      this.$router.push({
        name: "hostelDetail",
        params: {
          id: id
        }
      });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : {
          campus_id: this.$store.state.user.campus_id,
          search_status: this.searchBtnStatus
        };
      axios.get('/hostel/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `hostel_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.searchBtnStatus,
        searchFn: this.searchHostel,
        listFn: this.getHostel
      })
    },
  },

  mounted() {
    this.isLoading = true;
    this.getHostel();
  },
};
